//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Builder.js";
import "../no/PDM.js";
let d=[[[0,"Fixtures",1,0],[0,"Insulation",1,0],[0,"SurroundingDataProximityDistance",1,0],[0,"SurroundingDataRecipeMethodType",1,0]],[[[],"GetSearchSubsetBuilder",{R_:{subsetBuilder:"Assemblies.SubsetBuilder"}},0,0],[["subsetBuilder"],"SetSearchSubsetBuilder",{},1,0],[[],"GetConfigurationContextBuilder",{R_:{configurationContext:"PDM.ConfigurationContextBuilder"}},0,0],[["runID"],"AppendSearchResultElementToSelectedList",{},1,0],[["runID"],"RemoveSearchResultElementFromSelectedList",{},1,0],[[],"RemoveAllSearchResultElementsFromSelectedList",{},0,0],[["inputSubsetBuilder"],"UpdateSubsetUsingConfigurationContext",{R_:{outputSubsetBuilder:"Assemblies.SubsetBuilder"}},1,0],[[],"SetRoutingSubsetAsWorkPart",{},0,0]],[]];
SPLM.Assemblies.MechanicalRoutingSubsetBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.MechanicalRoutingSubsetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.MechanicalRoutingSubsetBuilder.SurroundingDataRecipeMethod = Object.freeze({
    "None" : "None", "ProximitytoRoutingContent" : "ProximitytoRoutingContent", "Manual" : "Manual"});

export default SPLM;